// extracted by mini-css-extract-plugin
export var iconLinks = "IconLinks-module--iconLinks--30b68";
export var link = "IconLinks-module--link--a7cb1";
export var row = "IconLinks-module--row--3a66b";
export var rowReverse = "IconLinks-module--rowReverse--3c135";
export var stack = "IconLinks-module--stack--24822";
export var stackReverse = "IconLinks-module--stackReverse--b85ed";